import React from 'react';
import { I18n } from 'react-redux-i18n';
import { MAX_IMAGE_FILE_COUNT, MAX_VIDEO_FILE_COUNT } from 'constants/ticket';
import RingSpinner from 'components/Spinner/Ring';
import Blocker from 'components/Blocker';
import FileUploadZone from './FileUploadZone';
import FileGrid from './FileGrid';
import './BatchUploader.scss';

const BatchUploader = ({
    fileUploadDisabled,
    files,
    uploading,
    imageFiles,
    videoFiles,
    handleFileSelect,
    removeFile,
    acceptedTypes,
    children
}) => {
    const allFilesReady = files.length > 0 && files.every(file => file.thumbnailUrl);
    const compressError = files.some(file => file.status === 'error');
    const isCompressing = files.length > 0 && !allFilesReady;

    return (
        <div className="batch-uploader">
            {isCompressing && !compressError && (
                <Blocker>
                    <RingSpinner />
                </Blocker>
            )}
            {allFilesReady ? (
                <div className="file-list">
                    {(imageFiles.length > 0 || videoFiles.length > 0) && (
                        <FileGrid
                            files={[...imageFiles, ...videoFiles]}
                            onRemoveFile={removeFile}
                            uploading={uploading}
                            videoFiles={videoFiles}
                            imageFiles={imageFiles}
                        />
                    )}
                </div>
            ) : (
                <span className="file-count-description">
                    {
                        I18n.t('attachments_can_select_files',
                            {
                                videoCount: MAX_VIDEO_FILE_COUNT,
                                imageCount: MAX_IMAGE_FILE_COUNT
                            }
                        )
                    }
                </span>
            )}
            <div className="submit-wrapper">
                <FileUploadZone
                    onFileSelect={handleFileSelect}
                    fileUploadDisabled={fileUploadDisabled
                        || (imageFiles.length >= MAX_IMAGE_FILE_COUNT
                            && videoFiles.length >= MAX_VIDEO_FILE_COUNT)
                    }
                    acceptedTypes={acceptedTypes}
                />
                { children }
            </div>
        </div>
    );
};

export default BatchUploader;
